import type { ClassTypeId } from '@/features/class/manage/types';

/** Maximum characters for a class display name (create / edit). */
export const CLASS_NAME_MAX_LENGTH = 35;

/** Maximum characters for a profile class category name. */
export const CLASS_CATEGORY_NAME_MAX_LENGTH = 35;

export const CLASS_TYPE_OPTIONS: readonly { id: ClassTypeId; label: string }[] = [
  { id: 'homeroom', label: 'Homeroom/Form Class' },
  { id: 'subject', label: 'Subject Class' },
  { id: 'communication', label: 'Communication Channel' },
] as const;

export const CLASS_TYPE_BACKEND_IDS: Record<ClassTypeId, 1 | 2 | 3> = {
  homeroom: 1,
  subject: 2,
  communication: 3,
};

export const CLASS_DOT_COLORS: readonly string[] = [
  'bg-[#f87171]',
  'bg-[#fb923c]',
  'bg-[#fbbf24]',
  'bg-[#34d399]',
  'bg-[#60a5fa]',
  'bg-[#a78bfa]',
  'bg-[#f472b6]',
  'bg-[#c084fc]',
] as const;
